<template>
  <div class="home-news news-container">
    <img src="@/views/web/home/imgs/newsBanner.png" style="width: 100%" />
    <div class="topTitle">
      <div
        style="
          width: fit-content;
          margin: 0 auto;
          line-height: 64px;
          display: flex;
        "
      >
        <p class="backBtn" @click="back">
          Current location: News&nbsp;> &nbsp;
        </p>
        {{ news.title }}
      </div>
    </div>

    <div class="news">
      <div class="title">{{ news.title }}</div>

      <div class="line"></div>

      <div class="date">
        {{ news.date ? $uniFun.formatDateSimple(news.date) : news.date }}
      </div>

      <template v-if="news.type == 1">
        <div v-html="news.content" class="content"></div>
      </template>
      <template v-else>
        <div class="videoBox" v-if="news.videoUrl">
          <video controls :poster="news.coverPicUrl">
            <source :src="news.videoUrl" type="video/mp4" />
          </video>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { news1, news2, news3 } from "./news";

import { newsDetailApi } from "@/api/website";
export default {
  name: "newsDetail",
  props: {},
  components: {},
  data() {
    return {
      news: {},
    };
  },
  computed: {},
  created() {},
  mounted() {
    if (this.$route.query.id === "1") {
      this.news = news1;
    } else if (this.$route.query.id === "2") {
      this.news = news2;
    } else if (this.$route.query.id === "3") {
      this.news = news3;
    }
    this.getDetail();
  },
  methods: {
    back() {
      this.$uniFun.openInCurrentTab(
        `/pc_index/news?&classification=${this.$route.query.classification}&page=${this.$route.query.page}`,
      );
    },
    getDetail() {
      let params = { id: this.$route.query.id };
      newsDetailApi(params).then((res) => {
        if (res.code === 200 && res.success) {
          console.log("newsDetailApi", res);
          this.news = {
            title: res.data.title,
            type: res.data.type,
            date: res.data.effectiveTime
              ? res.data.effectiveTime.split(" ")[0]
              : res.data.effectiveTime,
            content: res.data.content,
            videoUrl:
              res.data.videoUrlIdList.length > 0
                ? res.data.videoUrlIdList[0].path
                : "",
            coverPicUrl:
              res.data.coverUrlIdList.length > 0
                ? res.data.coverUrlIdList[0].path
                : "",
          };
          console.log("news", this.news);
        }
      });
    },
  },
};
</script>

<style lang="scss">
.home-news.news-container {
  background: white;
  padding-bottom: 38px;
  .topTitle {
    width: 100%;
    height: 64px;
    margin: 0 auto;
    font-weight: 400;
    font-size: 18px;
    color: #1d1d1f;
    line-height: 64px;
    text-align: left;
    font-style: normal;
    border-bottom: 1px solid #d8d8d8;
  }

  .backBtn {
    cursor: pointer;
    line-height: 64px;
  }
  .backBtn:hover {
    color: #0035fb;
    border-bottom: 2px solid #0035fb;
  }

  .news {
    /* position: relative;
  top: 38px; */
    margin: 38px auto 0;
    width: 1048px;
    background: #fbfbfb;
    padding: 29px 76px;
    display: flex;
    flex-direction: column;
    gap: 16px;

    .title {
      font-weight: 600;
      font-size: 24px;
      color: #384257;
      line-height: 32px;
      text-align: left;
      font-style: normal;
    }
    .line {
      width: 100%;
      height: 1px;
      background: #dbdbdb;
    }

    .date {
      width: fit-content;
      height: 16px;
      font-weight: 400;
      font-size: 16px;
      color: #999999;
      line-height: 24px;
      text-align: center;
      font-style: normal;
      margin: 0 auto;
    }

    .content {
      margin-top: 24px;

      h2 {
        font-weight: bold;
        font-size: 16px;
        color: #666666;
        line-height: 32px;
        text-align: justify;
        font-style: normal;
      }

      p {
        font-weight: 400;
        font-size: 16px;
        color: #666666;
        line-height: 32px;
        text-align: left;
        font-style: normal;
      }

      figcaption {
        font-weight: 400;
        font-size: 16px;
        color: #666666;
        line-height: 32px;
        text-align: center;
        font-style: normal;
      }
      img {
        max-width: 100%;
      }
    }
    .videoBox {
      width: 100%;
      height: 590px;
      padding: 10px;
      box-sizing: border-box;
      background: #e4e7ed;
      border-radius: 8px;
      border: 1px solid #f8f8f8;
      video {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
